import * as React from "react";

function SvgHeadingIcon(props) {
  return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" {...props}><path d="M15.3 1.1c-.7 0-1.4.5-1.4 1.4v6.3H6.1V2.5c0-.7-.5-1.4-1.4-1.4-.7 0-1.4.5-1.4 1.4v14.9c0 .9.7 1.4 1.4 1.4s1.4-.5 1.4-1.4v-6.3h7.7v6.3c0 .9.7 1.4 1.4 1.4s1.4-.5 1.4-1.4V2.5c.1-.7-.4-1.4-1.3-1.4z" /></svg>;
}

export default SvgHeadingIcon;